/*
 * Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

export const maintenancePageStyles = {
  teaserImage: {
    width: "100%",
    marginTop: "8rem",
  },
  container: {
    textAlign: "center",
  },
  button: {
    marginTop: "20px",
    width: "300px",
  },
};
